import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actionGetDivisoes,
  actionSelectDivisao,
} from "../../../features/dados-loja/divisoes/slices";
import factoryOptionsFields from "../../../helpers/factory-fields";
import { getUser } from "../../../helpers/user";
import Select from "./../../Select";
import { useAppSelector } from "../../../hooks/useAppSelector";

interface IPropsSelectDivisoes {
  idDivisao?: string;
  lojas?: Array<any>;
  onChange?: any;
}

interface IDivisaoItem {
  id: number;
  nome: string;
}

const SelectDivisoes = (props: IPropsSelectDivisoes) => {
  const dispatch = useDispatch();
  const { acesso } = getUser();
  const allowed = acesso.divisao;

  const handleChange = (ev: any) => {
    const {
      target: { value },
    } = ev;
    if (props.onChange) {
      props.onChange(ev);
      dispatch(actionSelectDivisao(value));
    } else {
      dispatch(actionSelectDivisao(value));
    }
  };

  const divisaoSelected = useAppSelector(
    (state) => state.getDivisoes.divisaoSelected,
  );
  const divisoes = useAppSelector((state) => state.getDivisoes.divisoes);

  React.useEffect(() => {
    if (allowed) {
      dispatch(actionGetDivisoes());
    }
  }, []);

  React.useEffect(() => {
    const listaDivisoes = divisoes as IDivisaoItem[];

    if (listaDivisoes && listaDivisoes.length > 0) {
      const brasilOption = listaDivisoes.find((d) => d.nome === "BRASIL");

      if (brasilOption && !divisaoSelected && !props.idDivisao) {
        dispatch(actionSelectDivisao(brasilOption.id));
      }
    }
  }, [divisoes, divisaoSelected, props.idDivisao, dispatch]);

  if (!allowed) {
    return null;
  }

  return (
    <Select
      options={factoryOptionsFields.divisoes(divisoes)}
      label="Divisão"
      name="idDivisao"
      show={false}
      onChange={handleChange}
      value={props.idDivisao || divisaoSelected || ""}
      size="sm"
    />
  );
};

export default SelectDivisoes;
